import { Injectable, inject } from '@angular/core';
import { SocketioService } from '../SocketService/socketio.service';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private static isLoggedIn: boolean = false;  // ログイン状態を保持する変数
  private static isAdmin: boolean = false;

  constructor(private socketio: SocketioService) { }

  async login(email: string, password: string): Promise<any> {
    const res = await this.socketio.emitEvent('auth', { email, password });
    if (res.status) {
      await this.socketio.setAuthenticatedSession(res.sessionToken, res.isAdmin === true);
      AuthService.isLoggedIn = true;
      AuthService.isAdmin = res.isAdmin === true;
    } else {
      await this.socketio.clearAuthenticatedSession();
      AuthService.isLoggedIn = false;
      AuthService.isAdmin = false;
    }
    return res;
  }

  async loginWithPasskey(result: any): Promise<any> {
    if (result?.status && typeof result.sessionToken === 'string') {
      await this.socketio.setAuthenticatedSession(result.sessionToken, result.isAdmin === true);
      AuthService.isLoggedIn = true;
      AuthService.isAdmin = result.isAdmin === true;
      return result;
    }
    await this.socketio.clearAuthenticatedSession();
    AuthService.isLoggedIn = false;
    AuthService.isAdmin = false;
    return result;
  }

  async logout(): Promise<void> {
    // ログアウト処理
    await this.socketio.logoutSession();
    AuthService.isLoggedIn = false;
    AuthService.isAdmin = false;
  }

  markUnauthenticated(): void {
    AuthService.isLoggedIn = false;
    AuthService.isAdmin = false;
  }

  isAuthenticated(): boolean {
    // 現在のログイン状態を返す
    return AuthService.isLoggedIn;
  }

  isAdministrator(): boolean {
    return AuthService.isAdmin;
  }

  async restoreSession(): Promise<boolean> {
    if (AuthService.isLoggedIn) return true;
    try {
      const response = await this.socketio.restoreAuthentication();
      AuthService.isLoggedIn = response?.status === true;
      AuthService.isAdmin = response?.isAdmin === true;
      return AuthService.isLoggedIn;
    } catch {
      AuthService.isLoggedIn = false;
      AuthService.isAdmin = false;
      return false;
    }
  }

  static authGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const auth = inject(AuthService);
    if (AuthService.isLoggedIn) {
      return true;
    } else {
      return auth.restoreSession().then(restored => restored
        ? true
        : router.parseUrl(`login/${encodeURIComponent(state.url)}`));
    }
  }
}
